module.exports = __webpack_public_path__ + "static/media/positioning-bottom-left_24.c40044c4.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/icons/lib/positioning-bottom-left_24.svg
// module id = 885
// module chunks = 0